
import React from "react";
import "./CitiesList.css"
const CitiesList = () => {
  const cities = [
"Electronic City",
"Whitefield",
"Marathahalli",
"Sarjapur Road",
"HSR Layout",
"Hebbal",
"Bellandur",
"Koramangala",
"Indiranagar",
"JP Nagar",
"Kadubeesanahalli",
"Hoodi",
"Gottigere",
"Audgodi",
"Hulimavu",
"Murugesh Palya",
"Ejipura",
"Mahadevapura",
"Doddanekkundi",
"Hongasandra",
"Padmanabha Nagar",
"Kumaraswamy Layout",
"Bommenahalli",
"CV Raman Nagar",
"Ramamurthy Nagar",
"Brookefield",
"Hosur Road",
"Domlur",
"Panathur",
"Hosa Road",
"Kadugodi",
"AECS Layout",
"Singasandra",
"Jigani",
"Banashankari ",
"Varthur Road",
"Kudlu",
"MG Road",
"Jeevanbheema Nagar",
"Konanakunte",
"Roopena Agrahara",
"Ramagondanahalli",
"Sadduguntepalya",
"Attibele",
"Anekal Road",
"Chikkathoguru",
"Kothanoor",
"Kanakapura Road",
"Kaggadasapura",
"Bilekahalli",
"Begur",
"Munnekollal",
"TC Palya Road",
"ITPL Road",
"Vignana Nagar",
"B Narayanapura",
"Bannerghatta",
"Chikkalasandra",
"Vasanthapura",
"Talaghattapura",
"Kaggalipura",
"Kumbalgodu",
"BTM Layout",
"Murugeshpalya",
"Horamavu Agara",
"ISRO Layout",
"KR Puram",
"Carmelaram",
"Kundalahalli",
"Budigere",
"Haralur Road",
"Chandapura",
"Hoskote",
"Arekere",
"Bommasandra",
"Dommasandra",
"Yemalur",
"Silk Board",
"Battarahalli",
"Madiwala",
"Doddenahalli",
"Jayanagar",
  ];
  return (
    <section className="citiesList-container">
      <h2 className="citiesList-title">
        1Hr Free Pick-Up from Bangalore Localities{" "}
      </h2>

      <div className="citiesList-grid">
        {cities.map((city, index) =>
          city === "Book a Free Visit" ? (
            <button key={index} className="city-card book-visit-btn">
              {city}
            </button>
          ) : (
            <div key={index} className="city-card">
              {city}
            </div>
          ),
        )}
      </div>
    </section>
  );
};

export default CitiesList;
